import { Features } from 'generated/featureDefinitions'

import { useFeatureAvailability } from 'modules/core/hooks/useFeatureAvailability'
import hasFeature from 'modules/core/lib/hasFeature'

export interface FeatureAvailable {
  loading: boolean
  availability: boolean
}

const useFeatureAvailable = (name: string): FeatureAvailable => {
  const { loading, featureAvailability } = useFeatureAvailability(name)

  return { loading, availability: featureAvailability.available }
}

const useShiftManagementEnabled = (): FeatureAvailable => {
  return useFeatureAvailable(Features.shift_management_management)
}

export const useHasShiftManagement = () => {
  const { loading, availability } = useShiftManagementEnabled()

  return {
    canUseShiftManagement: hasFeature('dev_packaging_paywalls')
      ? availability
      : hasFeature('shift_management'),
    loading,
  }
}
